import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _InvoicesFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6201 1.50049C19.7247 1.50049 20.6201 2.39592 20.6201 3.50049V13.5874L19.1904 12.1577L19.1895 12.1587L19.1846 12.1528L18.9951 11.981C18.0144 11.1767 16.5776 11.2086 15.6328 12.0776C15.6054 12.1029 15.5779 12.1295 15.5518 12.1558L12.6221 15.0864C11.6201 16.0888 11.62 17.7131 12.6221 18.7153L12.8164 18.8921C13.3112 19.2956 13.9212 19.4829 14.5254 19.4614L13.0127 21.2671C12.4132 21.9818 11.3134 21.9818 10.7139 21.2671L9.17871 19.436C8.54557 18.6814 7.38667 18.6724 6.74219 19.4175L4.37598 22.1528C3.77015 22.8532 2.62049 22.4254 2.62012 21.4995V3.50049C2.62012 2.39592 3.51555 1.50049 4.62012 1.50049H18.6201ZM8.37012 10.5005C7.9559 10.5005 7.62012 10.8363 7.62012 11.2505C7.62012 11.6647 7.9559 12.0005 8.37012 12.0005H14.8701C15.2843 12.0005 15.6201 11.6647 15.6201 11.2505C15.6201 10.8363 15.2843 10.5005 14.8701 10.5005H8.37012ZM7.37012 6.50049C6.9559 6.50049 6.62012 6.83627 6.62012 7.25049C6.62012 7.6647 6.9559 8.00049 7.37012 8.00049H15.8701C16.2843 8.00049 16.6201 7.6647 16.6201 7.25049C16.6201 6.83627 16.2843 6.50049 15.8701 6.50049H7.37012Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1293 13.2183C18.1277 13.2166 18.126 13.2149 18.1244 13.2133C17.7185 12.8075 17.0671 12.797 16.6486 13.1819C16.6364 13.1931 16.6245 13.2046 16.6129 13.2163L13.6825 16.1466C13.266 16.5632 13.266 17.2386 13.6825 17.6551C14.0991 18.0717 14.7745 18.0717 15.191 17.6551L16.3035 16.5427V21.4342C16.3035 22.0233 16.781 22.5009 17.3701 22.5009C17.9592 22.5009 18.4368 22.0233 18.4368 21.4342V16.5427L19.5492 17.6552C19.9658 18.0717 20.6411 18.0717 21.0577 17.6552C21.4743 17.2386 21.4743 16.5632 21.0577 16.1467L18.1293 13.2183Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const InvoicesFilledIcon = assignWithoutSideEffects(_InvoicesFilledIcon, {
  componentId: 'InvoicesFilledIcon',
});

export default InvoicesFilledIcon;
